import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import ModuleLoaderLazy from '../redux/ModuleLoaderLazy';
import AbsoluteHeightLayout from '@wix/da-ds/pkg/AbsoluteHeightLayout';
import variables from '@wix/da-ds/src/styles/variables.scss';
const siteHeaderHeight = parseInt(variables['site-header-height'], 10);
const FeedbackPage = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "notifications_shared" */ './index')));
export const FeedbackPageLoadable = ({ loadingIndicator })=>{
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "FeedbackPageLoadable"
    }, /*#__PURE__*/ React.createElement(AbsoluteHeightLayout, {
        heightReduction: siteHeaderHeight
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: loadingIndicator || null
    }, /*#__PURE__*/ React.createElement(ModuleLoaderLazy, null), /*#__PURE__*/ React.createElement(FeedbackPage, null))));
};
FeedbackPageLoadable.displayName = 'FeedbackPageLoadable';
export default FeedbackPageLoadable;
